import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function Section({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('border-b border-border-subtle px-4 py-4', className)}>
      <h3 className="mb-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-fg-subtle">
        {title}
      </h3>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
